module.exports = __webpack_public_path__ + "fonts/SimplerPro_V3-Regular.a50962c9.otf";